export const HomeLinkRoutes = {
  login: '/login',
  register: '/register',
  resetPassword: '/reset-password',
  logout: '/logout',
  redirect: '/redirect',
  terms: '/terms',
  home: '/',
  exchangeToken: '/exchange-token',

  // patient routes
  patient: '/patient',
  patientMedical: '/patient/medical',
  patientPharmacy: '/patient/pharmacy',
  patientAppointments: '/patient/appointments',
  patientChat: '/patient/chat',
  patientChatChannel: '/patient/chat/:channelId',
  patientVideoCall: '/patient/video-call/:appointmentId',
  patientPharmacyVerifyPayment:
    '/patient/pharmacy/verifyPayment/:appointmentId',
  patientMedicalVerifyPayment: '/patient/medical/verifyPayment/:appointmentId',
  patientCreateNewMedicalAppointment: '/patient/medical/create-new-appointment',
  patientCreateNewPharmacyAppointment:
    '/patient/pharmacy/create-new-appointment',
  patientProfile: '/patient/profile',
  patientProfileInfo: '/patient/profile/info',
  patientProfileInfoInitial: '/patient/profile/enter-info',
  patientProfilePayment: '/patient/profile/payment',
  patientProfileNotification: '/patient/profile/notification',
  patientHelp: '/patient/help',
  patientNotifications: '/patient/notifications',
  // doctor/pharmacist routes
  medical: '/medical',
  // calendar with all appointments
  medicalAppointments: '/medical/appointments',
  medicalAppointmentEdit: '/medical/appointments/edit',
  medicalAppointmentRebook: '/medical/appointments/rebook',
  medicalAppointmentRequests: '/medical/appointments/requests',
  medicalVideoCall: '/medical/video-call/:appointmentId',
  medicalSchedule: '/medical/schedule',
  medicalPaymentHistory: '/medical/payment-history',
  medicalChat: '/medical/chat',
};
